import React from 'react';
import { DictionaryType } from './core/types/DictionaryType';

type AppContextType = {
  appSettings: DictionaryType<string> | undefined;
  translations: DictionaryType<string> | undefined;
  styles: DictionaryType<DictionaryType<string>>;
  defaultLanguage: string | undefined;
  isHideMypageCases: boolean | undefined;
};

const AppContext = React.createContext<AppContextType>({} as AppContextType);

const useAppContext = () => {
  const context = React.useContext(AppContext);

  if (!context) {
    throw new Error(`There is no context`);
  }

  return context;
};

export { AppContext, useAppContext };
